export class TerminalActionsSsbtReport {
    public date: Date;
    public userFirstName: string;
    public userLastName: string;
    public terminalActionTypeId: number;
    public amount: number;
    public newPartnerAccountingState: number;
  }



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-actions-ssbt-report/terminal-actions-report.type.ts